import {NewsPost} from "../../../data/models/sponsor_api/NewsPost";
import Grid from "@mui/material/Grid";
import NewsRow from "./NewsRow";
import Typography from "@mui/material/Typography";
import {Divider, Theme, useMediaQuery, useTheme} from "@mui/material";
import {useEffect, useState} from "react";
import Paper from '@mui/material/Paper';
import FeedIcon from '@mui/icons-material/DynamicFeed';

type NewsFeedProps = {
    news: NewsPost[];
}
export default function NewsFeed({news}: Readonly<NewsFeedProps>){
    const [isMdOrUp, setIsMdOrUp] = useState(useMediaQuery((theme: Theme) => theme.breakpoints.up('md')));

    useEffect(() => {

        const handleResize = () => {
            setIsMdOrUp(window.innerWidth >= 960);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [isMdOrUp]);

    return(
        <Grid container sx={{
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
        }}>
            <Grid container sx={{
                maxHeight: isMdOrUp ? '50vh': '100vh',
                width: isMdOrUp ? '80vw' : '95vw',
                overflowY: 'auto',
                overflowX: 'hidden',
                marginY: 1,
                backgroundColor: 'background.paper',
                borderRadius: '10px',
                boxShadow: 2,
                p: 2,
            }}>
                <Grid item xs={12} sx={{display: 'flex', alignItems: 'center', mb: 2}}>
                    <FeedIcon sx={{mr: 1, color: 'primary.main'}} />
                    <Typography variant="h5" sx={{fontWeight: 'bold'}}>News Feed</Typography>
                </Grid>
                {news.length === 0 && (
                    <Typography variant="body1" color="text.secondary" sx={{p: 2}}>
                        No news available.
                    </Typography>
                )}
                {news.map((post, idx) => (
                    <Paper key={post.title || idx} elevation={1} sx={{p: 2, mb: 2, width: '100%', borderRadius: 2, backgroundColor: 'background.default'}}>
                        {NewsRow(post)}
                    </Paper>
                ))}
            </Grid>
        </Grid>
    )
}